import { Component, computed, signal } from '@angular/core';
import { CustomCellComponent } from '@vendasta/galaxy/table';
import type { Timer } from '@vendasta/protos/crm/v1/types';
import { FieldValueWithTimer } from '@galaxy/crm/services/adapter-service';
import { TimerBadgeComponent } from '../../timer-badge/timer-badge.component';

@Component({
  selector: 'crm-timer-cell',
  templateUrl: './timer-cell.component.html',
  imports: [TimerBadgeComponent],
})
export class TimerCellComponent extends CustomCellComponent {
  public set value(newValues: (FieldValueWithTimer | null)[]) {
    this.fieldValues.set(newValues ?? []);
  }

  protected readonly fieldValues = signal<(FieldValueWithTimer | null)[]>([]);

  protected readonly timer = computed<Timer | null>(
    () => this.fieldValues().find((fieldValue) => fieldValue?.timerValue)?.timerValue ?? null,
  );
}
